var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCapVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 85,
    viewBox: "0 0 121 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5014 0C58.9827 0 57.4828 0.262493 56.0578 0.768731L3.46531 19.762C1.68411 20.4183 0.502886 22.1057 0.502886 23.9994C0.502886 25.8931 1.68411 27.5806 3.46531 28.2368L14.3213 32.1555C11.2464 36.9929 9.50267 42.7115 9.50267 48.7301V53.9987C9.50267 59.3236 7.47772 64.8172 5.32152 69.1483C4.1028 71.5858 2.71533 73.9857 1.10287 76.1982C0.502886 77.0044 0.33414 78.0544 0.671632 79.0106C1.00912 79.9668 1.7966 80.6793 2.77158 80.9231L14.7713 83.923C15.5588 84.1292 16.4025 83.9792 17.0962 83.548C17.79 83.1168 18.2775 82.4043 18.4275 81.5981C20.0399 73.5732 19.2337 66.3734 18.0337 61.2173C17.4337 58.5548 16.6275 55.8362 15.5025 53.3425V48.7301C15.5025 43.0677 17.415 37.7241 20.7337 33.4492C23.1523 30.543 26.2835 28.1993 29.9584 26.7556L59.3952 15.1871C60.9327 14.5872 62.6764 15.3371 63.2764 16.8746C63.8764 18.4121 63.1264 20.1558 61.5889 20.7558L32.1521 32.3242C29.8272 33.243 27.7835 34.6492 26.1148 36.3741L56.0391 47.1739C57.464 47.6801 58.964 47.9426 60.4827 47.9426C62.0014 47.9426 63.5014 47.6801 64.9263 47.1739L117.538 28.2368C119.319 27.5993 120.5 25.8931 120.5 23.9994C120.5 22.1057 119.319 20.4183 117.538 19.762L64.9451 0.768731C63.5201 0.262493 62.0202 0 60.5014 0ZM24.5023 70.4983C24.5023 77.1169 40.6269 83.998 60.5014 83.998C80.376 83.998 96.5006 77.1169 96.5006 70.4983L93.6319 43.2365L66.97 52.8737C64.8888 53.6237 62.6951 53.9987 60.5014 53.9987C58.3077 53.9987 56.0953 53.6237 54.0328 52.8737L27.371 43.2365L24.5023 70.4983Z",
    fill: "url(#paint0_linear_164_2919)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_164_2919",
    x1: 0.5,
    y1: 42.0072,
    x2: 120.5,
    y2: 42.0072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapVector);
export default __webpack_public_path__ + "static/media/capVector.d9c8666facf39cc5af945e288f5eedc1.svg";
export { ForwardRef as ReactComponent };